import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './workspace.css';
import './lib/i18n';
import App from './App';

// A tab left open across a deployment may reference a removed lazy-loaded chunk.
window.addEventListener('vite:preloadError', (event) => {
  const lastReload = Number(sessionStorage.getItem('asset-reload-at') || 0);
  if (Date.now() - lastReload > 60000) {
    sessionStorage.setItem('asset-reload-at', String(Date.now()));
    event.preventDefault();
    window.location.reload();
  }
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
